export const WHATSAPP_NUMBER = '5585987046533'
export const WHATSAPP_DISPLAY_NUMBER = '+55 85 98704-6533'
